import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from "src/core/services/data.service";
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { computed } from "mobx";

export class PlaceListDataService extends DataService<typeof Model.General.Logic.ViewModels.PlaceSummary, Model.General.Logic.ViewModels.PlaceSummary, PlaceSummary> {
	protected map(entity: Model.General.Logic.ViewModels.PlaceSummary): PlaceSummary {
		return new PlaceSummaryModel(entity);
	}

	public static make(context?: any): PlaceListDataService {
		return new PlaceListDataService(context, ctx => ctx.PlacesSummaries);
	}
}

export class PlaceSummaryModel extends EntityModel<Model.General.Logic.ViewModels.PlaceSummary, PlaceSummary> implements PlaceSummary {

	@property<PlaceSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<PlaceSummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
	public displayName: string;

	@property<PlaceSummaryModel>(o => o.entity.regionName, (o, value) => o.entity.regionName = value)
	public regionName: string;

	@property<PlaceSummaryModel>(o => o.entity.type, (o, value) => o.entity.type = value)
	public type: Model.General.Domain.Models.PlaceType;
	@property<PlaceSummaryModel>(o => o.entity.parentPlaceId, (o, value) => o.entity.parentPlaceId = value)
	public parentPlaceId?: number;
	@property<PlaceSummaryModel>(o => o.entity.hasChildren, (o, value) => o.entity.hasChildren = value)
	public hasChildren: boolean;

	@computed public get typeText(): string {
		switch (this.entity.type) {
			case 0:
				return 'General';
			case 1:
				return 'Airport';
			case 2:
				return 'Resort';
			case 3:
				return 'Transfer Point';
			case 4:
				return 'Coach Pickup Point';
		}
		return null;
	}

	@property<PlaceSummaryModel>(o => o.entity.regionId, (o, value) => o.entity.regionId = value)
	public regionId: number;
}



// WEBPACK FOOTER //
// ./src/app/general/places/list/place-list.data.ts